import type { TraderReferralListPayload } from 'syncra-api-client'

/**
 * Определяет статус реферала на основе данных из API
 */
export const getReferralStatus = (item: TraderReferralListPayload): 'active' | 'paused' | 'blocked' | 'unconnect' | 'deleted' => {
  const user = item.user
  const merchant = item.merchant
  const trader = item.trader

  // Deleted (5) - юзер или мерчант/трейдер удалены
  if (user?.isDeleted || merchant?.isDeleted || trader?.isDeleted) {
    return 'deleted' // используем deleted для отображения удаленных
  }

  // Blocked (4) - юзер и/или мерчант/трейдер заблокированы
  if (user?.isBlocked || merchant?.isBlocked || trader?.isBlocked) {
    return 'blocked'
  }

  // NotVerified (3) - пользователь не верифицирован
  if (!user?.isVerified) {
    return 'unconnect'
  }

  // Active (2) - верифицирован и не заблокирован
  if (user?.isVerified && !user?.isBlocked) {
    return 'active'
  }

  return 'unconnect'
}

/**
 * Преобразует статус реферала в читаемый текст на русском языке
 */
export const getReferralStatusText = (status: string): string => {
  switch (status) {
    case 'active': return 'Активен'
    case 'paused': return 'Приостановлен'
    case 'blocked': return 'Заблокирован'
    case 'deleted': return 'Удален'
    case 'unconnect': return 'Не подключен'
    default: return 'Активен'
  }
}

/**
 * Маппинг статуса реферала на заголовок и цвет для отображения в StatusLabel
 */
export const getReferralStatusInfo = (
  status: 'active' | 'paused' | 'blocked' | 'unconnect' | 'deleted'
): { title: string; color: 'green' | 'red' | 'grey' | 'yellow' } => {
  const statusMap = {
    active: { title: 'Активен', color: 'green' as const },
    paused: { title: 'Неактивен', color: 'grey' as const },
    blocked: { title: 'Заблокирован', color: 'red' as const },
    unconnect: { title: 'Не верифицирован', color: 'yellow' as const },
    deleted: { title: 'Удален', color: 'red' as const },
  }
  return statusMap[status] || statusMap.active
}
